import React from 'react'
import {
  Button,
  Grid,
  Modal,
  Stack,
  Typography,
  useMediaQuery
} from '@mui/material'
import WarningIcon from 'shared/assets/icons/warningicon.svg';
import { theme, MOBILE_BREAKPOINT_VAL } from '../../../theme/theme'

interface MobileSubscriberWarningProps {
  open: boolean
  setOpen: (open: boolean) => void
}

const MobileSubscriberWarningModal = (props: MobileSubscriberWarningProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Modal
      open={props.open}
      sx={{
        backdropFilter: 'blur(5px)',
        background: 'rgba(0, 0, 0, 0.01)',
      }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          maxWidth: `${MOBILE_BREAKPOINT_VAL}px`,
          transform: 'translate(-50%, -50%)',
          width: !isMobile ? '30%' : '80%',
          background: '#fff',
          p: { xs: 5, sm: 6, md: 8 },
          borderRadius: '10px',
        }}>

        <Stack justifyContent="center" alignItems="center" flexDirection={'column'}>
          <img src={WarningIcon} style={{ width: '8vw', maxWidth: '100px', minWidth: '60px', height: 'auto', }} />
          <Typography
            variant="h2"
            mt={{ xs: 2, sm: 2, md: 3, lg: 3 }}
            textAlign="center"
            sx={{
              fontSize: { xs: 18, md: 21, lg: 23 },
              fontWeight: 600,
              lineHeight: { xs: 1, md: 1.2, lg: 1.5 },
            }}>
            Manage your subscription in the Meprism Mobile App
          </Typography>
          <Typography
            variant="body2"
            textAlign="center"
            color={'#615F6B'}
            my={{ xs: 2, sm: 2, md: 3, lg: 3 }}
            sx={{
              fontSize: { xs: 12, md: 14, lg: 16 },
              lineHeight: { xs: 1.2, md: 1.2, lg: 1.5 },
              letterSpacing: '0'
            }}>
            Your subscription is currently managed through the Meprism mobile app.
            Please use the app&apos;s subscription page to make any updates or changes.
          </Typography>
        </Stack>
        <Grid container rowSpacing={2} mt={1}>
          <Grid item xs={12} sm={12} justifyContent="center" display="flex">
            <Button
              variant={'contained'}
              color={'darkPurple'}
              onClick={() => {
                props.setOpen(false)
              }}
              sx={{
                width: { xs: '90%', sm: '100%', lg: '63%' },
                borderRadius: '10px',
                fontSize: { xs: 8, md: 13, lg: 14 },
                boxShadow: 'unset',
                border: '2px solid #9135E0',
                color: '#fff',
                background: '#9135E0',
                '&.Mui-disabled': {
                  background: 'white',
                  color: '#9135E0',
                  border: '2px solid #9135E0',
                },
                ':hover': {
                  color: '#fff',
                  background: '#9135E0',
                },
              }}>
              Close
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default MobileSubscriberWarningModal